export default __webpack_public_path__ + "static/media/FreeShipping.376b2e9b.png";